module.exports = __webpack_public_path__ + "img/BentonSansBBVA-Light.7715e26e.svg";